
import Spinner from 'vux/src/components/spinner/index.vue'


export default {
name:'noOrder',
components:{
Spinner
},
data () {
return {
loading:true,
}
},
created (){
let self = this;
setTimeout(function(){
self.loading = false;
},800)
}
}



// WEBPACK FOOTER //
// ./src/components/normal/noData/noOrder.vue